import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { MeterData } from "@/pages";
import React from "react";
import { permissionsEnergy } from "@/utils";

export const locationMeterDataRoutes = (
  _parentPath: string,
): React.ReactElement[] => [
  <Route
    key="data"
    path=""
    element={
      <ProtectedRoute element={<MeterData />} codes={permissionsEnergy} />
    }
  />,
];
